import { EditorState, TextSelection } from 'prosemirror-state';

/**
 * This is a command to join two non text blocks together after backspacing requires a join of two nodes.
 * Example ( where | is your current selection) ---- <h1>some text</h1>|<a>other text </a> -> <h1>some text|<a>other text</a></h1>
 * @param state The current state of the editor.
 * @param dispatch To be able to send the commands out to the editor.
 * @returns Return true if successfully sent out commands.
 */
export function joinInlineNodeToTextBlock(state: EditorState, dispatch?: ProsemirrorDispatcher): boolean {
  const selection = state.selection;
  const $cut = selection.$head;
  const tr = state.tr;

  if (selection.empty && !$cut.parentOffset && !$cut.parent.isTextblock) {
    if (dispatch) {
      tr.deleteRange($cut.pos - 2, $cut.pos + $cut.parent.nodeSize);
      tr.insert($cut.pos - 3, $cut.parent);
      tr.setSelection(TextSelection.near(tr.doc.resolve($cut.pos - 3)));
      dispatch(tr.scrollIntoView());
    }
    return true;
  }
  return false;
}
